import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import { format, parse, isValid, toDate } from "date-fns";
import Input from "Components/UI/Input";
import dayjs from "dayjs";
import { useGetShiftSheduleQuery } from "AppQuries/shift/schedule/scheduler";
import moment from "moment";
import { useGetProjectsQuery } from "AppQuries/project/project";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { DatePicker, Select } from "antd";
import { useGetAllShiftPoliciesQuery } from "AppQuries/shift/policy/shift-policy";
import {
  useFormattedEmployees,
  useFormattedExcluedEmployeesOptions,
} from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import { useFormattedProjectOption } from "core/Operations/formattedOption/useFormattedMasterOptions";
import DragSelect from "Components/UI/DragSelect";

const { RangePicker } = DatePicker;
const options = [
  { id: 0, label: "Absent", value: 0 },
  // { id: 1, label: "Half Day", value: 0.5 },
  { id: 2, label: "Present", value: 1 },
];

const TimeLogModal = ({ mode = "I", onSubmit, show = false, handleClose }) => {
  const userData = useSelector(loggedInUser);
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    trigger,
  } = useFormContext();
  const companyCode = watch("companyCode");
  const employeeCode = watch("employeeCode");
  const [multiEmployee, setIsMultiEmloyee] = useState(false);

  const attendanceDate =
    watch("attendanceDate") || format(new Date(), "yyyy-MM-dd");
  const locationCode = watch("locationCode");

  const employeeOptions = useFormattedExcluedEmployeesOptions({
    companyCode,
    locationCode,
  });

  const projectsOptions = useFormattedProjectOption({
    companyCode,
    locationCode,
  });

  const { data: shifts } = useGetAllShiftPoliciesQuery({
    isTrue: true,
    companyCode,
    locationCode,
  });
  const shiftOptions = Array.isArray(shifts)
    ? shifts.map((r) => ({
        label: `${r.shiftName} - (${r.locationCode})`,
        value: r.shiftPolicyID.toString(),
        startTime: r.shiftStartTime,
        endTime: r.shiftEndTime,
      }))
    : [];

  const shiftHandler = (selectedOption) => {
    const selectedShift = shiftOptions.find((s) => s.value === selectedOption);

    setValue("manualEntryData.shiftId", selectedOption);
    setValue("manualEntryData.haveShift", true);
    setValue("manualEntryData.inTime", selectedShift.startTime);
    setValue("manualEntryData.outTime", selectedShift.endTime);
  };

  return (
    <Modal show={show} onHide={handleClose} animation centered size="lg">
      <Modal.Header
        className="modal-header border-0 custom-modal-header "
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>{mode === "I" ? "Add Attendance" : "Edit Attendance"}</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
          <div className="form-row row">
            <div className="col-12 mb-3">
              {/*  */}
              <div
                className="form-check form-check-lg form-switch"
                style={{ paddingLeft: "30px" }}
              >
                <label
                  className="form-label form-check-label"
                  htmlFor="employee-type"
                >
                  Multiple Employees ?
                </label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="employee-type"
                  onChange={() => {
                    console.log("Switch");
                    setValue("manualEntryData.employeeCode", 0);
                    setValue("manualEntryData.selectedEmployees", []);
                    trigger("manualEntryData.employeeCode");
                    trigger("manualEntryData.selectedEmployees");
                    setIsMultiEmloyee(!multiEmployee);
                  }}
                  style={{ margin: "5px" }}
                />
              </div>
            </div>

            <div className="col-12 mb-3">
              <div className="form-floating">
                {multiEmployee ? (
                  // <DragSelect options={employeeOptions} />
                  <Select
                    name="manualEntryData.selectedEmployees"
                    // type="commonSelect"
                    placeholder="Select Employee"
                    className={`form-control select ${
                      errors.selectedEmployees ? "is-invalid" : ""
                    }`}
                    value={watch(`manualEntryData.selectedEmployees`) || []}
                    // label="Employee"
                    // labelClassName="form-label"
                    // required={true}
                    options={employeeOptions}
                    labelInValue={true}
                    mode="multiple"
                    onChange={(selectedOptions) => {
                      console.log(selectedOptions);
                      setValue(
                        "manualEntryData.selectedEmployees",
                        Array.isArray(selectedOptions)
                          ? selectedOptions.map((option) => option)
                          : []
                      );
                    }}
                    showSearch
                    allowClear
                    onClear={() => {
                      setValue("manualEntryData.selectedEmployees", []);
                    }}
                    style={{ width: "100%", height: "auto" }}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    // disabledDate={(current) => {
                    //   return current && current > dayjs().startOf("day");
                    // }}
                  />
                ) : (
                  <Select
                    name="manualEntryData.employeeCode"
                    value={watch("manualEntryData.employeeCode") || null}
                    // type="commonSelect"
                    placeholder=""
                    className={`form-control ${
                      errors.employeeCode ? "is-invalid" : ""
                    }`}
                    label="Employee"
                    labelClassName="form-label"
                    options={employeeOptions}
                    required
                    onChange={(selectedOption) => {
                      console.log(selectedOption);
                      setValue("manualEntryData.employeeCode", selectedOption);
                      trigger("manualEntryData.employeeCode");
                    }}
                    showSearch
                    optionFilterProp="label"
                    requiredMessage="Employee is required"
                    // defaultValue={watch("manualEntryData.employeeCode") !== 0 ? watch("manualEntryData.employeeCode") : ""}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    style={{ width: "100%" }}
                  />
                )}
                <label className="form-lable">
                  Employee
                  <span className="asterisk">*</span>
                </label>
              </div>
            </div>

            <div className="col-12 mb-3">
              <div className="form-floating">
                <RangePicker
                  className="form-control"
                  style={{ display: "flex" }}
                  onChange={(date, dateFormat) => {
                    setValue("manualEntryData.fromDate", dateFormat[0]);
                    setValue("manualEntryData.toDate", dateFormat[1]);
                  }}
                  defaultValue={[
                    dayjs(watch("manualEntryData.fromDate"), "YYYY-MM-DD"),
                    dayjs(watch("manualEntryData.toDate"), "YYYY-MM-DD"),
                  ]}
                  dateFormat="YYYY-MM-DD"
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  disabledDate={(current) => {
                    return current && current > dayjs().startOf("day");
                  }}
                />
                <label className="form-lable"> Attendance Date</label>
              </div>
            </div>

            <div className="col-6 mb-3">
              <Input
                name="manualEntryData.shiftId"
                type="commonSelect"
                placeholder=""
                className={`form-control ${
                  errors.projectId ? "is-invalid" : ""
                }`}
                label="Shift"
                labelClassName="form-label"
                optionData={shiftOptions}
                required={false}
                requiredMessage="Project is required"
                onSelect={shiftHandler}
                defaultValue={watch("manualEntryData.shiftId")}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                dropdownStyle={{
          minWidth: "fit-content" 
        }}
              />
            </div>

            <div className="col-6 mb-3">
              <Input
                name="manualEntryData.projectId"
                type="commonSelect"
                placeholder=""
                className={`form-control ${
                  errors.projectId ? "is-invalid" : ""
                }`}
                label="Project"
                labelClassName="form-label"
                optionData={projectsOptions}
                required={false}
                requiredMessage="Project is required"
                onChange={(selectedOption) => {
                  setValue(
                    "manualEntryData.projectId",
                    selectedOption ? selectedOption : null
                  );
                  trigger("manualEntryData.projectId");
                }}
                defaultValue={watch("manualEntryData.projectId")}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>

            <div className="col-6 mb-3">
              <Input
                name="manualEntryData.inTime"
                type="time"
                placeholder="In Time"
                className={`form-control ${
                  errors?.manualEntryData?.inTime ? "is-invalid" : ""
                }`}
                label="In Time"
                labelClassName="form-label"
                required={true}
                requiredMessage="In Time is required"
              />
            </div>

            <div className="col-6 mb-3">
              <Input
                name="manualEntryData.outTime"
                type="time"
                placeholder="Out Time"
                className={`form-control ${
                  errors?.manualEntryData?.outTime ? "is-invalid" : ""
                }`}
                label="Out Time"
                labelClassName="form-label"
                required={true}
                requiredMessage="Out Time is required"
              />
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="submit" className="btn btn-submit">
              Save
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

TimeLogModal.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default TimeLogModal;
